import React from 'react';

import * as s from './PostContentCollapserLayout.css';
/**
 * Декоратор для компонента CollapserUncontrolled
 */
export const PostContentCollapserLayout = ({ children }: { children: React.ReactNode }) => (
  <div className={s['wrapper']}>{children}</div>
);
